function Contact() {
  return (
    <div class="about-page">
      <h1>Contact</h1>
      <p>If you need to get in touch, you can contact me here:</p>
      <p>Email: thorntonjaiden5@gmail.com | X: @devclearly</p>
    </div>
  );
}

export default Contact;